<!-- <div class="dis-flex justify-content-center resumen-votacion-mobile-c flex-column d-flex d-xl-none"> -->
<div class="dis-flex justify-content-center resumen-votacion-mobile-c flex-column d-none">
	<h1 class="title">Total de votos</h1>
	<p class="totalPrincipal">{{total_num}}</p>
	<p *ngIf="!hide_prc" class="totalPorcentaje">{{total_prc}}</p>
</div>